import { Effects } from './types';

export const NAMESPACE = 'remixer';

export const DEFAULT_EFFECTS_ORDER = [
  Effects.radio,
  Effects.destroyer,
  Effects.heavenLow,
  Effects.spaciousness,
  Effects.master,
];
